<template>
    <div class="el-card pd20">
        <el-tabs v-model="tab_model" @tab-click="changeTab" class="tab" type="border-card" >
            <!-- 判断如果是添加初始化就不显示其它选项卡,（执行顺序是：for循环执行了才会执行v-if） -->
            <el-tab-pane v-for="(item,index) in tab_list" v-if="item.title!='基础设置'&& form_type?false:true" :key="index" :name="item.title" >
                <span :class="['tab-span',(item.title!='基础设置'&&form_type)?'disabled':'']" slot="label"><i :class="item.icon"></i> {{item.title}}</span>
                <div class="mt"></div>
                <!-- 基础设置 -->
                <basis @basisSuccessHandle="basisSuccessHandle" :id="id" :type="$route.query.type" v-if="item.title == '基础设置' && tab_model=='基础设置'" ></basis>
                <!-- 测评维度 -->
                <dimensions :eid="eid" v-if="item.title == '维度设置' && tab_model=='维度设置'"></dimensions>
                <!-- 试题设置 -->
                <question :eid="eid"  v-if="item.title == '试题设置' && tab_model=='试题设置'"></question>
                <!-- 公式设置 -->
                <formula-set :eid="eid"  v-if="item.title == '公式设置' && tab_model=='公式设置'"></formula-set>
                 <!-- 显示设置 -->
                <according :eid="eid"  v-if="item.title == '显示设置' && tab_model=='显示设置'"></according>
                <!-- 动态文字 -->
                <dynamic-text :index='tab_index'   v-if="item.title == '动态文字' && tab_model=='动态文字'"></dynamic-text>
                <!-- 动态图片 -->
                <dynamic-image :index='tab_index' :eid="eid"  v-if="item.title == '动态图片' && tab_model=='动态图片'"></dynamic-image>
                <!-- 动态图表 -->
                <dynamic-graph :eid="eid"  v-if="item.title == '动态图表' && tab_model=='动态图表'"></dynamic-graph>
                <!-- 动态海报 -->
                <dynamic-posters :eid="eid"  v-if="item.title == '动态海报' && tab_model=='动态海报'"></dynamic-posters>
                <!-- 报告页面 -->
                <report :eid="eid"  v-if="item.title == '报告页面' && tab_model=='报告页面'"></report>
                <!-- 测评预览 -->
                <evaluation-preview :eid="eid"  v-if="item.title == '测评预览' && tab_model=='测评预览'"></evaluation-preview>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Basis from './component/Basis'
import Dimensions from './component/Dimensions'
import Question from './component/Question'
import FormulaSet from './component/FormulaSet'
import DynamicText from './component/DynamicText'
import DynamicImage from './component/DynamicImage'
import DynamicGraph from './component/DynamicGraph'
import According from './component/According'
import DynamicPosters from './component/DynamicPosters'
import Report from './component/Report'
import EvaluationPreview from './component/EvaluationPreview'
import { getStorage,setStorage } from '@u/tools'

export default {
    data (){
        return{
            tab_list:[],
            form_type:false,
            id:'',
            tab_model:'',
            eid:'',
            tab_index:0
        }
    },
    components: {
        Basis,
        Dimensions,
        Question,
        FormulaSet,
        DynamicGraph,
        DynamicText,
        DynamicImage,
        According,
        DynamicPosters,
        Report,
        EvaluationPreview
    },
    methods:{
        changeTab(tab,even){
            this.tab_index = tab.index;
            setStorage('measurement_tab',tab.name);
        },
        basisSuccessHandle(obj){
            this.form_type = obj.bool;
            this.eid = obj.id;
            this.tab_model = '维度设置';

        },
        pullData(){
            if(this.$route.query.type=='add'){
                this.form_type = true;
            }else if(this.$route.query.type=='edit'){
                this.id = this.$route.query.id;
                this.eid = this.$route.query.id;
                this.form_type = false;
            }
            this.tabInitData();

            this.tab_model = getStorage('measurement_tab')?getStorage('measurement_tab') :'基础设置';
        },
        tabInitData(){
            this.tab_list = [
                {
                    icon:'el-icon-setting',
                    title:'基础设置'
                },
                {
                    icon:'el-icon-menu',
                    title:'维度设置'
                },
                {
                    icon:'el-icon-tickets',
                    title:'试题设置'
                },
                {
                    icon:'el-icon-data-line',
                    title:'公式设置'
                },
                {
                    icon:'el-icon-zoom-in',
                    title:'显示设置'
                },
                {
                    icon:'el-icon-edit',
                    title:'动态文字'
                },
                {
                    icon:'el-icon-picture-outline',
                    title:'动态图片'
                },
                {
                    icon:'el-icon-pie-chart',
                    title:'动态图表'
                },
                {
                    icon:'el-icon-collection',
                    title:'动态海报'
                },
                {
                    icon:'el-icon-data-analysis',
                    title:'报告页面'
                },
                {
                    icon:'el-icon-view',
                    title:'测评预览'
                }
            ];
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.tab{
    .disabled{
        opacity: .7;
    }
    .tab-span{
        font-size: 14px;
    }
    .mt{
        margin: 20px auto;
    }
}
</style>

